/**
 * Collectie-grid met vast aantal producten per pagina.
 * Haalt alle producten op, filtert op voorraad, en pagineert client-side.
 */
(function() {
  const PER_PAGE = 24;
  const LIMIT = 250;

  /**
   * Format price for display. Shopify JSON APIs can return prices in cents (e.g. 4500)
   * or in main currency (e.g. 45). Only divide by 100 when value is clearly in cents (>= 100).
   */
  function formatMoney(val) {
    var num = typeof val === 'string' ? parseFloat(val) : (val || 0);
    if (num >= 100 && num === Math.floor(num)) {
      num = num / 100;
    }
    return num.toFixed(2).replace('.', ',');
  }

  function buildProductCard(product) {
    const v = product.variants && product.variants[0] ? product.variants[0] : {};
    const priceNum = typeof v.price === 'string' ? parseFloat(v.price) : (v.price || 0);
    const compareNum = typeof v.compare_at_price === 'string' ? parseFloat(v.compare_at_price) : (v.compare_at_price || 0);
    const img = product.images && product.images[0] ? product.images[0] : null;
    const url = '/products/' + (product.handle || '');
    const price = formatMoney(priceNum);
    const comparePrice = compareNum ? formatMoney(compareNum) : null;
    const onSale = compareNum && compareNum > priceNum;
    const discountPercent = onSale && compareNum ? Math.round((1 - priceNum / compareNum) * 100) : 0;
    const isNew = product.tags && product.tags.some(function(t) { return t.toLowerCase() === 'nieuw'; });
    const vendor = product.vendor || '';

    let badge = '';
    if (onSale) badge = '<span class="product-badge badge-sale">-' + discountPercent + '%</span>';
    else if (isNew) badge = '<span class="product-badge badge-new">Nieuw</span>';

    let priceHtml = '';
    if (onSale) {
      priceHtml = '<span class="price-sale">' + price + '</span><span class="price-compare">' + comparePrice + '</span>';
    } else {
      priceHtml = '<span class="price-regular">' + price + '</span>';
    }

    let imgSrc = '';
    if (img) {
      imgSrc = typeof img === 'string' ? img : (img.src || '');
      if (imgSrc && !imgSrc.includes('_600x') && !imgSrc.includes('_600x600')) {
        imgSrc = imgSrc.replace(/(\.[a-z]+)(\?|$)/i, '_600x600$1$2');
      }
    }
    const imgHtml = imgSrc
      ? '<img src="' + imgSrc + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" class="product-img" loading="lazy" width="600" height="600">'
      : '<div class="product-img" style="aspect-ratio:1;background:#f5f5f5;"></div>';

    return '<div class="product-item">' +
      '<a href="' + url + '" class="product-card">' +
        '<div class="product-image-wrap">' + badge +
          imgHtml +
        '</div>' +
        '<div class="product-info">' +
          '<div class="product-vendor-wrap"><p class="product-vendor">' + vendor + '</p></div>' +
          '<h3 class="product-name">' + (product.title || '').replace(/</g, '&lt;') + '</h3>' +
          '<div class="product-price">' + priceHtml + '</div>' +
        '</div>' +
      '</a>' +
    '</div>';
  }

  function init(container) {
    const handle = container.getAttribute('data-collection-handle');
    const sortBy = container.getAttribute('data-sort-by') || '';
    const grid = container.querySelector('.products-grid');
    const pagination = container.querySelector('.col-pagination');
    const emptyEl = container.querySelector('.col-empty');
    const sectionId = container.getAttribute('data-section-id') || '';

    if (!handle || !grid) return;

    grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:48px;color:#666;">Producten laden...</div>';
    if (pagination) pagination.style.display = 'none';
    if (emptyEl) emptyEl.style.display = 'none';

    var baseUrl = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + LIMIT;
    if (sortBy) baseUrl += '&sort_by=' + encodeURIComponent(sortBy);
    let allProducts = [];
    let pageNum = 1;
    let hasMore = true;

    function fetchPage() {
      const url = baseUrl + '&page=' + pageNum + (sortBy ? '&sort_by=' + sortBy : '');
      return fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          const prods = data.products || [];
          allProducts = allProducts.concat(prods);
          hasMore = prods.length >= LIMIT;
          pageNum++;
          if (hasMore) return fetchPage();
        });
    }

    fetchPage()
      .then(function() {
        const available = allProducts.filter(function(p) {
          if (p.available !== undefined) return p.available;
          const v = p.variants && p.variants[0];
          return v ? v.available : false;
        });

        if (available.length === 0) {
          grid.innerHTML = '';
          if (emptyEl) {
            emptyEl.style.display = 'block';
            emptyEl.querySelector('a').setAttribute('href', '/collections/' + handle);
          }
          return;
        }

        const totalPages = Math.ceil(available.length / PER_PAGE);
        let currentPage = 1;

        function render() {
          const start = (currentPage - 1) * PER_PAGE;
          const slice = available.slice(start, start + PER_PAGE);
          grid.innerHTML = slice.map(buildProductCard).join('');
          window.scrollTo({ top: 0, behavior: 'smooth' });

          if (pagination && totalPages > 1) {
            pagination.style.display = 'flex';
            pagination.innerHTML = '';

            if (currentPage > 1) {
              const prev = document.createElement('a');
              prev.href = '#';
              prev.className = 'page-btn';
              prev.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg> Vorige';
              prev.addEventListener('click', function(e) { e.preventDefault(); currentPage--; render(); });
              pagination.appendChild(prev);
            }

            const dots = document.createElement('span');
            dots.className = 'page-dots';
            dots.textContent = currentPage + ' / ' + totalPages;
            pagination.appendChild(dots);

            if (currentPage < totalPages) {
              const next = document.createElement('a');
              next.href = '#';
              next.className = 'page-btn';
              next.innerHTML = 'Volgende <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>';
              next.addEventListener('click', function(e) { e.preventDefault(); currentPage++; render(); });
              pagination.appendChild(next);
            }
          }
        }

        render();
      })
      .catch(function(err) {
        console.error('Collection grid error:', err);
        grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:48px;color:#999;">Kon producten niet laden. Vernieuw de pagina.</div>';
      });
  }

  document.querySelectorAll('[data-collection-grid-consistent]:not([data-use-liquid="true"])').forEach(init);
})();
